const defaultTextValues = {

  sectionTitle: {
    en: 'Quote'
  },
  quoteContainer: {
    en: '"I was there and it was great!"'
  },
  authorName: {
    en: 'Bilb Gabes'
  },
  authorJob: {
    en: 'Macrohard'
  },
};

export default defaultTextValues;

